import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

interface DataRowProps {
  label: string;
  value: ReactNode;
  muted?: boolean;
  className?: string;
  'data-testid'?: string;
}

export function DataRow({ label, value, muted = false, className, 'data-testid': testId }: DataRowProps) {
  return (
    <div className={cn('py-1', className)} data-testid={testId}>
      <dt className="text-xs text-muted-foreground md:text-sm">{label}</dt>
      <dd
        className={cn(
          'mt-0.5 text-sm font-medium md:text-base',
          muted ? 'text-muted-foreground' : 'text-foreground',
        )}
      >
        {value ?? '—'}
      </dd>
    </div>
  );
}
